import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import moment from "moment-timezone";
import "moment-timezone";
import {Link} from "react-router-dom";

import Spinner from "components/loaders/spinner";
import AssetBasic from "site-apps/assets/components/AssetBasic";
import ModalEditUnload from "./ModalEditUnload";
import UnloadCell from "./UnloadCell";
import ConditionalRender from "../../../components/ConditionalRender";

const UnloadTimeModel = {
    item: null,
    date: null,
    time: null,
    value: 0,
    level: 0,
    exists: false,
};

const PreHeaderModel = {
    days: 0,
    month: 0,
    year: 0,
};

const UnloadsTable = ({itemsShown, setItemsShown, isLoading = false, filters}) => {
    const {t: _Td} = useTranslation("datestimes");
    const [preHeader, setPreHeader] = useState([]);
    const [dateHeaders, setDateHeaders] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalItem, setModalItem] = useState(null);

    useEffect(() => {
        if (itemsShown && itemsShown.length) {
            const startDate = moment(filters.current.start, "DD/MM/YYYY");
            const endDate = moment(filters.current.end, "DD/MM/YYYY");
            const dates = [];
            const preHeaders_ = {};
            while (startDate.isSameOrBefore(endDate)) {
                let month = startDate.month() + 1;
                if (!(month in preHeaders_)) {
                    preHeaders_[month] = {
                        ...PreHeaderModel,
                        month: month,
                        year: startDate.year(),
                    };
                }
                dates.push({
                    day: startDate.date(),
                    date: startDate.format("DD-MM-YYYY"),
                });
                startDate.add(1, "day");
                preHeaders_[month].days++;
            }
            setPreHeader(Object.values(preHeaders_));
            setDateHeaders(dates);
        }
    }, [itemsShown]);

    const styleDayHeader = {
        maxWidth: "100px",
        minWidth: "100px",
        textAlign: "center",
        verticalAlign: "middle",
        width: "100px",
        top: "138px",
    };
    const styleDayBody = {
        maxWidth: "100px",
        minWidth: "100px",
        textAlign: "center",
        verticalAlign: "middle",
        width: "100px",
    };
    const handleClickEdit = (e) => {
        let tr = e.currentTarget.closest("tr");
        let unload = {...UnloadTimeModel};
        let date = e.currentTarget.dataset.date;
        unload.item = itemsShown[tr.dataset.idx];
        unload.item.idx = parseInt(tr.dataset.idx);
        unload.date = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");

        let cell = e.currentTarget.querySelector(".data-cell");
        if (cell) {
            unload.value = cell.dataset.value;
            unload.time = cell.dataset.time;
            unload.level = cell.dataset.level;
            unload.exists = true;
            const unload_ = unload.item.unloads[date].find((u) => u.time === unload.time);
            unload.timestamp = unload_.timestamp;
        }
        setModalItem(unload);
        setShowModal(true);
    };

    return (
        <>
            <div className="col-12">
                <hr className="mb-3" />
                {isLoading ? (
                    <Spinner text="Cargando datos..." />
                ) : (
                    <>
                        {!itemsShown || itemsShown.length === 0 ? (
                            <div className="alert alert-secondary text-center">No hay datos disponibles</div>
                        ) : (
                            <table className="table table-striped sticky-horizontal">
                                <thead>
                                    <tr>
                                        <th style={{top: "106px"}} className="sticky-top border-bottom-sticky"></th>
                                        {preHeader.map((pre, idx) => (
                                            <th
                                                key={idx}
                                                colSpan={pre.days}
                                                className="text-center border-start sticky-top border-bottom-sticky"
                                                style={{top: "106px"}}>
                                                {_Td("months_name." + pre.month) + " / " + pre.year}
                                            </th>
                                        ))}
                                    </tr>
                                    <tr>
                                        <th
                                            style={{
                                                width: "180px",
                                                minWidth: "180px",
                                                top: "138px",
                                            }}
                                            className="sticky-top border-bottom-sticky">
                                            UID - UUID - Dirección
                                        </th>
                                        {dateHeaders.map((date, idx) => (
                                            <th
                                                key={idx}
                                                style={styleDayHeader}
                                                className="sticky-top border-bottom-sticky border-start">
                                                {date.day}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody id="data-list">
                                    {itemsShown.map((item, index) => (
                                        <tr key={index} data-idx={index}>
                                            <td>
                                                <Link
                                                    to={"/data-view/data-container/unloads/" + item.uid + "/"}
                                                    className="slx-link">
                                                    <AssetBasic asset={item} />
                                                </Link>
                                            </td>
                                            {dateHeaders.map((date, idx) => {
                                                if (date.date in item.unloads) {
                                                    return (
                                                        <td
                                                            key={idx}
                                                            className="text-center border-start cursor-pointer data-unloads"
                                                            style={styleDayBody}>
                                                            <UnloadCell
                                                                item={item}
                                                                date={date}
                                                                handleClickEdit={handleClickEdit}
                                                            />
                                                        </td>
                                                    );
                                                } else {
                                                    return (
                                                        <td
                                                            key={idx}
                                                            className="text-center border-start cursor-pointer data-unloads"
                                                            style={styleDayBody}
                                                            data-date={date.date}
                                                            data-uuid={item.uuid}
                                                            onClick={handleClickEdit}>
                                                            <div></div>
                                                        </td>
                                                    );
                                                }
                                            })}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </>
                )}
            </div>
            <ConditionalRender condition={showModal}>
                <ModalEditUnload
                    show={showModal}
                    setShow={setShowModal}
                    item={modalItem}
                    itemsShown={itemsShown}
                    setItemsShown={setItemsShown}
                />
            </ConditionalRender>
        </>
    );
};

export default UnloadsTable;
